import {
  BillingInfo,
  CardInfo,
  Coupon,
  NextPaymentInfo,
  Subscription,
} from "../Subscription";
import { MockCardInfo } from "./MockCardInfo";
import { MockSubscription } from "./MockSubscription";

export class MockBillingInfo implements BillingInfo {
  public subscription: Subscription = new MockSubscription();
  public card: CardInfo = new MockCardInfo();
  public scaTokenSecret?: string | undefined;
  public coupons?: Coupon[] | undefined;
  public nextPayment?: NextPaymentInfo | undefined;
}
